<template>
    <b-modal 
      id="basic-modal"
      centered
      ok-variant="warning"
      cancel-variant="dark"
      :hide-footer="hideFooter"
      ref="my-modal"
      :size="size"
    >
        <!-- Modal title section-->
        <template #modal-title>
          {{ title }}
        </template>
        <!-- Modal first section -->
        <main>
          <slot name="main"></slot>
        </main>
        <!-- Modal second section section -->
        <!-- Buttons section -->
        <template #modal-footer>
          <div class="w-100">
            <slot name="footer"></slot>
          </div>
        </template>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
  name:'basic-modal',
  components: {
    BModal
  },
  props: {
    // title of the modal, will appear on the header
    title: String,
    // need an array of object, this list of buttons will replace the default buttons "cancel" and "ok"
    buttons: Object,
    // on true, hide the footer with buttons
    hideFooter: {
      type: Boolean,
      default: false
    },
    // type of the modal, will defines the color of the header
    type: {
      type: String,
      enum: ['success', 'error'],
      default: ''
    },
    // force the size
    width: String,
    height: String,
    size: {
      type: String,
      enum: ['sm', 'md', 'lg', 'xl'],
      default: 'md'
    }
  },
  methods: {
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    }
  }
}
</script>

<style lang="scss">
/* Not scoped to target the bootstrap components */
:root {
  --modal-padding-x: 1.5rem;
}
.modal-content {
  border: none;
}
.modal-header {
  border: none;
  padding: 1rem var(--modal-padding-x) 1rem;
  .close {
    font-size: 2rem;
    font-weight: 400;
    line-height: .75;
  }
}
.modal-body {
  padding: 1rem var(--modal-padding-x);
}
.modal-footer {
  border: none;
  padding: 1rem var(--modal-padding-x) 1rem;
  * {
    margin: 0;
  }
}

#basic-modal {
  /* header */
  // .modal-header {
  //   border: none;
  //   align-items: center;
  //   box-shadow: 0px 0.1px 5px 0px grey;
  //   border-radius: 0px !important;
  // }
  // .modal-header {
  //   background-color: #ffc107 !important;
  // }
  // .modal-title {
  //   color: #333333;
  //   margin-bottom: -8px;
  //   margin-left: 10px;
  // }

  // /* footer */
  // .modal-footer {
  //   background-color: white;
  //   border-radius: 0px !important;
  // }
  // .btn {
  //   border-radius: 0px !important;
  //   width: 110px;
  // }
  // .close {
  //   text-shadow: none;
  //   margin-right: -8px;
  // }
  // :focus {
  //   outline-style: none !important;
  // }
}
.modal-backdrop {
  opacity: 0.5;
}
</style>
